import type {FC} from 'react';

import type {PortableTextOverrides} from '@/modules/foundation/sanity/portable-text';

import type {ContentBlockContainerProps} from '../block-container';
import {ContentBlockContainer} from '../block-container';

interface Props extends ContentBlockContainerProps {
	fullWidth?: boolean;
	insideToc?: boolean;
}

export const textPortableTextOverrides: PortableTextOverrides = {};

export const Text: FC<Props> = ({children, options, insideToc}) => {
	const {fullWidth, ...rest} = options ?? {};
	return (
		<ContentBlockContainer
			width={fullWidth ? 'screen' : (options?.width ?? 'text')}
			options={{...rest}}
			insideToc={insideToc}
		>
			{children}
		</ContentBlockContainer>
	);
};
